class BtCardColorSwatches extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => this.onSwatchClick(event));
  }

  onSwatchClick(event) {
    const button = event.target.closest('button[data-variant-id]');
    if (!button || !this.contains(button)) return;

    event.preventDefault();
    event.stopPropagation();

    const card = this.closest('.card');
    const image = card?.querySelector('.card__media img');
    if (!card || !image) return;

    image.src = button.dataset.imageSrc;
    image.srcset = button.dataset.imageSrcset;
    image.alt = button.dataset.imageAlt || '';
    image.width = Number(button.dataset.imageWidth);
    image.height = Number(button.dataset.imageHeight);
    image.closest('.media')?.classList.add('bt-card-color-selected');

    const productUrl = new URL(button.dataset.productUrl, window.location.origin);
    productUrl.searchParams.set('variant', button.dataset.variantId);
    card.querySelectorAll('.card__heading a').forEach((link) => {
      link.href = productUrl.toString();
    });

    this.querySelectorAll('button[data-variant-id]').forEach((swatch) => {
      swatch.setAttribute('aria-pressed', String(swatch === button));
    });
  }
}

if (!customElements.get('bt-card-color-swatches')) {
  customElements.define('bt-card-color-swatches', BtCardColorSwatches);
}